import axios from "../axios"

const userApi = {
	login({
		loginName,
		passWord
	}) {
		return axios({
			url: `/api/Login/Login`,
			method: "post",
			data: {
				loginName,
				passWord,
			}
		})
	},
	
	queryRole() {
		return axios({//查询角色列表
			url: `/api/Role/Query`,
			method: "post",
		})
	},
	addRole(data) {
		return axios({//修改角色
			url: `/api/Role/CreateOrEdit`,
			method: "post",
			data
		})
	},
	
	deleteRole(id) { //删除角色
		return axios({
			url: `/api/Role/Delete`,
			method: "post",
			params:{id}
		})
	},
	
	queryUserRole(userId) { //查询用户角色
		return axios({
			url: `/api/UserRole/GetByUserRole`,
			method: "post",
			params:{userId}
		})
	},
	
	queryRoleUser(data) { //查询角色用户
		return axios({
			url: `/api/UserRole/QuseryHJRoleUsers`,
			method: "post",
			data
		})
	},
	
	editUserRole(data) { //修改用户角色
		return axios({
			url: `/api/UserRole/CreateOrEdit`,
			method: "post",
			data
		})
	},
	
	deleteUserRole(id) { //删除用户角色
		return axios({
			url: `/api/UserRole/Delete`,
			method: "post",
			params:{id}
		})
	},
	
	changePwd(data) { //修改密码
		return axios({
			url: `/api/Account/editpassword`,
			method: "post",
			data
		})
	},
	resetPwd(userId) { //重置密码 
		return axios({
			url: `/api/Account/ReSetPassWord`,
			method: "post",
			params:{userId}
		})
	},
	
	changeUserName(oldLoginName,newLoginName) { //修改用户名
		return axios({
			url: `/api/Account/ReEditLoginName`,
			method: "post",
			params:{oldLoginName,newLoginName}
		})
	},
	
	queryUser(data) { //查询用户列表
		return axios({
			url: `/api/Account/Query`,
			method: "post",
			data
		})
	},
	
	queryUserRoleSelf() { //查询用户自己角色
		return axios({
			url: `/api/UserRole/QueryCurrentUser`,
			method: "post",
		})
	},
	queryUserInfo(data) { //查询用户信息列表
		return axios({
			url: `/api/Account/UserInfoSearch`,
			method: "post",
			data
		})
	},
	editUserInfo(data) { //修改用户信息列表
		return axios({
			url: `/api/Account/UpdateUserInfo`,
			method: "post",
			data
		})
	},
	editUserStatus(userid,sta) { //修改用户信息列表
		return axios({
			url: `/api/Account/UserStatusSave`,
			method: "post",
			params:{userid,sta}
		})
	},
	
	getPwdVertifyLists(data) { //查询密码申诉
		return axios({
			url: `/api/UserFindBack/Query`,
			method: "post",
			data
		})
	},
	
	checkDefined(id,status,remark='') { //保存申诉审核
		return axios({
			url: `/api/UserFindBack/UpdateHJUserFindBack`,
			method: "post",
			data:{id,status,remark}
		})
	},
	
	addPwdApply(data) { //密码申诉
		return axios({
			url: `/api/UserFindBack/SaveHJUserFindBack`,
			method: "post",
			data
		})
	},
	
	regisComs(data) { //企业注册
		return axios({
			url: `/api/Login/regist`,
			method: "post",
			data
		})
	},
}
export default userApi
